import { BuildingTypeModel } from './buildingType.model';
import { UserModel } from './user.model';
UserModel
export class BuildingModel
{
	id: number = undefined;
	//building_type_id: number = 0;
	name: string = undefined;
	notes: string = undefined;
	photo: string = undefined;
	map: string = undefined;
	organigram: string = undefined;
	adress1: string = undefined;
	adress2: string = undefined;
	zipcode: string = undefined;
	town: string = undefined;
	region: string = undefined;
	country: string = undefined;
	phone: string = undefined;
	email: string = undefined;
	director: string = undefined;
	datasheet:string = undefined;

	trash: number = 0;	//!important, sinon trash=null

	User: UserModel = undefined;
	BuildingType: BuildingTypeModel = undefined;

	get building_type_id()
	{
		return this.BuildingType.id;
	}
	set building_type_id(id)
	{

	}

	constructor(values: Object) {

	   if(values) this.exchange(values);
	   else {
	   	this.BuildingType = new BuildingTypeModel(null);
	   	this.User = null;// new UserModel(null);
	   }
	}
	exchange(values: Object = {}) {
		for (let p in values) {
		  if (this.hasOwnProperty(p) && values.hasOwnProperty(p)) {
	    	if(p == 'id' && this.id != undefined && this.id!=0) {
	    		continue;
	    	}
	    	else {
	    		this[p] = values[p];
	    	} 
	      }
	      else if (p == '_embedded') {
    		//this.exchange(values[p]);
    		this.setEmbedded(values[p]);
    	  }
	  }

		//this.building_type_id = this.BuildingType.id;
	}

	setEmbedded(embeddedValues)
	{
		this.User = new UserModel(embeddedValues.User);
		this.BuildingType = new BuildingTypeModel(embeddedValues.BuildingType);
	}

	export()
	{
		return {
			id: this.id,
			//building_type_id: this.building_type_id,
			BuildingType: this.BuildingType.id,
			name: this.name,
			notes: this.notes,
			photo: this.photo,
			map: this.map,
			organigram: this.organigram,
			adress1: this.adress1,
			adress2: this.adress2,
			zipcode: this.zipcode,
			town: this.town,
			region: this.region,
			country: this.country,
			phone: this.phone,
			email: this.email,
			director: this.director,
			datasheet: this.datasheet,
			trash: this.trash ? 1 : 0, //!important, sinon trash=null
		};
	}

	toString()
	{
		return "building.model "+this.name;
	}
}